import { AppBar, Toolbar } from "@mui/material";

export default function Footer() {
  return (
    <AppBar position="relative" sx={{ position: "absolute", bottom: 0, left: 0 }}>
      <Toolbar variant="dense"></Toolbar>
    </AppBar>
  );
}
